import React, { FC, ElementType } from 'react';

import { Button, Tooltip } from '@mui/material';

import styles from './styles';

interface IEditorToolbarItems {
  Icon: ElementType;
  handleClick: () => void;
  isActive: boolean;
  title: string;
}

const EditorToolbarItems: FC<IEditorToolbarItems> = ({
  Icon,
  handleClick,
  isActive,
  title,
}) =>
  (
    <Tooltip title={title}>
      <Button
        sx={[styles.buttonContainer, isActive ? styles.active : {}]}
        onClick={handleClick}
      >
        <Icon height={20} width={20} fontSize="small" />
      </Button>
    </Tooltip>
  );

export default EditorToolbarItems;
